// extracted by mini-css-extract-plugin
export default {"manageMultiplayerGame":"ManageMultiplayerGame_manageMultiplayerGame__2KUDW","modalContent":"ManageMultiplayerGame_modalContent__G8hUC","loader":"ManageMultiplayerGame_loader__oYkoR"};